import { Injectable } from '@angular/core';
import { BehaviorSubject,Subject,ReplaySubject} from 'rxjs';



@Injectable()
export class DataServiceService {
  private SharingData = new Subject<any>();
  data=this.SharingData.asObservable()
  
  constructor() {}
  
  changeData(data: any) {
    this.SharingData.next(data);
  }
}
